export enum MONITOR_SERIES_TYPES {
    RAIN_ALERT_III = 'RainAlert III',
    RAIN_ALERT_II = 'RainAlert II',
    ECHO = 'Echo',
    TRITON_PLUS = 'TRITON+',
    FORE_SITE = 'ForeSITE-UL',
    FORE_SITE_XD = "ForeSITE-XD",
    USGS = 'USGS',
    FLEX = 'FLEX',
}
